






























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { vxm } from '@/store'
import { Watch } from 'vue-property-decorator'
import DateField from '@/components/inputs/DateField.vue'
import { TableHeader } from '@/types/Vuetify'

@Component({
  components: {
    DateField,
  },
})
export default class List extends Vue {
  private isReady = false
  private loading = false
  private selectedRegister: string | null = null
  private startDate: string | null = null
  private endDate: string | null = null
  private verbosityLevel: number = 1
  private registers: Array<Record<string, unknown>> = []
  private journalEntries: Array<Record<string, unknown>> = []

  get registerOptions() {
    return this.registers.filter(register => register.id !== null)
  }

  get verbosityOptions() {
    return [
      { value: 1, text: this.$t('Journal') },
      { value: 2, text: this.$t('Info') },
      { value: 3, text: this.$t('Debug') },
    ]
  }

  get headers(): TableHeader[] {
    const baseHeaders: TableHeader[] = [
      { text: this.$t('Time'), value: 'time', sortable: true },
      { text: this.$t('User'), value: 'userName', sortable: true },
    ]

    if (this.verbosityLevel > 1) {
      baseHeaders.push({ text: this.$t('Level'), value: 'level', sortable: true })
    }

    baseHeaders.push(
      { text: this.$t('Description'), value: 'description', sortable: true },
      { text: this.$t('Amount'), value: 'amount', align: 'end', sortable: true }
    )

    if (this.verbosityLevel > 1) {
      baseHeaders.push({ text: this.$t('Reference'), value: 'reference', align: 'end', sortable: true })
    }

    baseHeaders.push({ text: this.$t('Artifact'), value: 'artifact', align: 'end', sortable: true })

    return baseHeaders
  }

  private created() {
    this.setDefaultDates()
    this.loadRegisters(() => {
      this.onRouteChange()
    })
  }

  private setDefaultDates() {
    const today = new Date()

    this.startDate = today.toISOString().split('T')[0]
    this.endDate = today.toISOString().split('T')[0]
  }

  @Watch('$route', { deep: true })
  private onRouteChange() {
    if (this.$route.query.registerId !== undefined) {
      this.selectedRegister = this.$route.query.registerId as string
    }
    if (this.$route.query.startDate !== undefined) {
      this.startDate = this.$route.query.startDate as string
    }
    if (this.$route.query.endDate !== undefined) {
      this.endDate = this.$route.query.endDate as string
    }
  }

  private loadRegisters(callback: () => void) {
    this.$axios
      .get('/v4/site/payment/cash-registers')
      .then((response) => {
        this.registers = response.data.data
        this.isReady = true
        callback()
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, this.$t('Failed to load list of cash registers'))
      })
  }

  private loadJournal() {
    if (!this.selectedRegister) {
      vxm.alert.warning(this.$t('Please select a cash register'))
      return
    }

    this.loading = true
    this.journalEntries = []
    const params = new URLSearchParams()

    if (this.startDate) {
      params.append('startTime', this.startDate)
    }
    if (this.endDate) {
      params.append('endTime', this.endDate)
    }
    if (this.verbosityLevel) {
      params.append('verbosity', this.verbosityLevel.toString())
    }

    this.$axios
      .get(`/v4/site/payment/cash-registers/${this.selectedRegister}/journal?${params.toString()}`)
      .then((response) => {
        this.journalEntries = response.data.data
        this.loading = false
      })
      .catch((err) => {
        this.loading = false
        vxm.alert.onAxiosError(err, this.$t('Failed to load journal entries'))
      })
  }

  private formatDateTime(dateString: string): string {
    return new Date(dateString).toLocaleString('sv-SE')
  }

  private formatAmount(amount: string | number): string {
    const num = parseFloat(amount as string)
    if (num === 0 || isNaN(num)) {
      return '-'
    }
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK'
    }).format(num).replace(',', '.').replace(/\s/g, ' ')
  }

  private formatDescription(item: Record<string, unknown>): string {
    if (item.description) {
      return item.description as string
    }
    if (item.type && item.action) {
      return `(${item.type}.${item.action})`
    }
    return '-'
  }

  private formatReference(item: Record<string, unknown>): string {
    if (item.operationId) {
      return `${this.$t('c:cash-register-journal-reference:Operation')} ${item.operationId}`
    }
    if (item.cashTransactionId) {
      return `${this.$t('c:cash-register-journal-reference:CashTransaction')} ${item.cashTransactionId}`
    }
    if (item.eventId) {
      return `${this.$t('c:cash-register-journal-reference:Event')} ${item.eventId}`
    }
    return ''
  }

  private formatLevel(verbosity: number): string {
    switch (verbosity) {
      case 1:
        return this.$t('Journal')
      case 2:
        return this.$t('Info')
      case 3:
        return this.$t('Debug')
      default:
        return '-'
    }
  }

  private getRowClass(item: Record<string, unknown>): string {
    if (item.verbosity === 3) {
      return 'debug-row'
    }
    return ''
  }

  private formatArtifact(item: Record<string, unknown>): string {
    if (item.receiptNumber) {
      return `${this.$t('Receipt')} ${item.receiptNumber}`
    }
    if (item.zReportId) {
      return `${this.$t('Z-Report')} ${item.zReportId}`
    }
    return '-'
  }
}
